import { DiameterOutlineIcon } from './DiameterOutlineIcon';

/**
 * author: Michael Richins
 * id ABE01F05-E04E-4C5F-8F70-F8A9DB484E89
 * name diameter-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diameter-outline.svg
 * tags
 * - Math 
 */
export const SphereDiameterOutlineIcon = DiameterOutlineIcon;
export default SphereDiameterOutlineIcon